var render, staticRenderFns
import script from "./CustomDivDownload.vue?vue&type=script&lang=js"
export * from "./CustomDivDownload.vue?vue&type=script&lang=js"
import style0 from "./CustomDivDownload.vue?vue&type=style&index=0&id=46c1e41a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c1e41a",
  null
  
)

export default component.exports